import * as React from "react";

import "./ComponentApiContent.scss";

import { Link } from "azure-devops-ui/Link";

export interface IApiTypeProps {
    typeName: string;
    children: React.ReactNode;
}

export const ApiType = (props: IApiTypeProps) => {
    return (
        <div className="component-api-type">
            <h3 className="component-api-type-title" id={"api-type-" + props.typeName.replace(/<.*>/, "")}>
                {props.typeName}
            </h3>
            <div className="component-api-properties-list">{props.children}</div>
        </div>
    );
};

export interface IApiPropertyProps {
    typeName: string;
    name: string;
    defaultValue?: string;
    optional?: boolean;
    deprecated?: boolean;
    deprecatedMessage?: string;
    propertyTypes?: string[];
    propertyTypeLinks?: string[];
    description: string;
    inheritedFrom?: string;
}

export const ApiProperty = (props: IApiPropertyProps) => {
    const {
        typeName,
        name,
        defaultValue,
        optional,
        deprecated,
        deprecatedMessage,
        propertyTypes,
        propertyTypeLinks,
        description,
        inheritedFrom
    } = props;
    const isPropsInterface = typeName.indexOf("Props") >= 0;
    return (
        <div className="component-api-property">
            <div className="component-api-property-name">
                {name}
                {defaultValue && (
                    <span className="component-api-property-decorator property-default-value" title={defaultValue}>
                        {defaultValue.trim()}
                    </span>
                )}
                {isPropsInterface && optional === false && <span className="component-api-property-decorator required-property">required</span>}
                {!isPropsInterface && optional === true && <span className="component-api-property-decorator optional-property">optional</span>}
                {inheritedFrom && (
                    <span className="component-api-property-decorator">
                        Inherited From: <span className="component-api-inherited-type">{inheritedFrom}</span>
                    </span>
                )}
                {deprecated && (
                    <span className="component-api-property-decorator deprecated-property" title={deprecatedMessage}>
                        deprecated
                    </span>
                )}
            </div>
            <ApiPropertyType typeNames={propertyTypes} typeLinks={propertyTypeLinks} />
            <ApiPropertyDescription description={description} />
        </div>
    );
};

export interface IApiPropertyTypeProps {
    typeNames?: string[];
    typeLinks?: string[];
}

export const ApiPropertyType = (props: IApiPropertyTypeProps) => {
    const { typeLinks, typeNames } = props;
    return (
        <div className="component-api-property-type">
            {typeNames &&
                typeNames.map((typeName, index) => {
                    const content =
                        typeLinks && !!typeLinks[index] ? (
                            <Link key={typeName + "-link"} href={typeLinks[index]}>
                                {typeName}
                            </Link>
                        ) : (
                            <span key={typeName + "-content"}>{typeName}</span>
                        );
                    return index < typeNames.length - 1 ? (
                        <React.Fragment key={typeName + "-content-container"}>
                            {content}
                            <span> | </span>
                        </React.Fragment>
                    ) : (
                        content
                    );
                })}
        </div>
    );
};

export interface IApiPropertyDescriptionProps {
    description: string;
}

export const ApiPropertyDescription = (props: IApiPropertyDescriptionProps) => {
    return <div className="component-api-property-description">{props.description}</div>;
};
